import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="onboarding-form"
export default class extends Controller {
  static targets = ["formContent", "title", "submit"];

  toggle(e) {
    // Resets submit button state
    this.submitTarget.textContent = "Save";
    this.#enableSubmitButton();

    const { formStepName, formStepTitle } = e.currentTarget.dataset;
    this.#setModalTitle(formStepTitle);

    // Load the template corresponding to the clicked step
    this.#loadTemplate(formStepName);

    if (formStepName === "image") {
      // Delay checking for image field since it's loaded from template
      setTimeout(() => {
        const imageField = document.getElementById("campaign_photo_attributes_image");
        if (imageField && !imageField.value) {
          this.#disableSubmitButton();
        }
      }, 0);
    }

    if (formStepName === "coordinator") {
      // Delay checking for coordinator field since it's loaded from template
      setTimeout(() => {
        const coordinatorField = document.getElementById("campaign_representative_id");
        if (coordinatorField && !coordinatorField.value) {
          this.#disableSubmitButton();
        }
      }, 0);
    }

    if (formStepName === "duration") {
      // Delay checking for end date field since it's loaded from template
      setTimeout(() => {
        const endDateField = document.getElementById("campaign_end_date");
        if (endDateField && !endDateField.value) {
          this.submitTarget.textContent = "Save without end date";
        }
      }, 0);
    }

    if (formStepName === "fulfillment") {
      // Delay checking for fulfillment fields since they're loaded from template
      setTimeout(() => {
        const pickupEnabledField = document.getElementById("campaign_is_pickup_enabled");
        const shippingEnabledField = document.getElementById("campaign_is_shipping_enabled");

        if (pickupEnabledField && shippingEnabledField && !(pickupEnabledField.checked || shippingEnabledField.checked)) {
          this.#disableSubmitButton();
        }
      }, 0);
    }

    if (formStepName === "payments") {
      // Delay checking for fulfillment fields since they're loaded from template
      setTimeout(() => {
        this.#validatePaymentMethods();
      }, 0);
    }
  }

  validateForm(event) {
    const fieldName = event.target.id;
    const value = event.target.value;

    if (fieldName === "campaign_title") {
      const doesNotHaveLetters = !/[a-zA-Z]/.test(value);
      if (value.trim() === "" || doesNotHaveLetters) {
        this.#disableSubmitButton();
      } else {
        this.#enableSubmitButton();
      }
    } else if (fieldName === "campaign_photo_attributes_image") {
      if (value) {
        this.#enableSubmitButton();
      }
    } else if (
      fieldName.includes("campaign_payment_methods_attributes_") ||
      fieldName.includes("accepts_payments_") ||
      fieldName.includes("enable_cash")
    ) {
      this.#validatePaymentMethods();
    } else if (fieldName === "campaign_photo_attributes__destroy") {
      if (event.target.checked) {
        this.#enableSubmitButton();
      } else {
        this.#disableSubmitButton();
      }
    } else if (fieldName === "campaign_end_date") {
      if (value) {
        this.submitTarget.textContent = "Save";
      } else {
        this.submitTarget.textContent = "Save without end date";
      }
    } else if (fieldName === "campaign_representative_id") {
      if (value) {
        this.#enableSubmitButton();
      } else {
        this.#disableSubmitButton();
      }
    } else if (fieldName === "campaign_is_shipping_enabled" || fieldName === "campaign_is_pickup_enabled") {
      const pickupEnabledField = document.getElementById("campaign_is_pickup_enabled");
      const shippingEnabledField = document.getElementById("campaign_is_shipping_enabled");

      if (pickupEnabledField && shippingEnabledField && (pickupEnabledField.checked || shippingEnabledField.checked)) {
        this.#enableSubmitButton();
      } else {
        this.#disableSubmitButton();
      }
    }
  }

  #disableSubmitButton() {
    this.submitTarget.disabled = true;
  }

  #enableSubmitButton() {
    this.submitTarget.disabled = false;
  }

  #loadTemplate(formStepName) {
    const template = document.getElementById(formStepName);
    if (template && this.hasFormContentTarget) {
      // Clear existing content
      this.formContentTarget.innerHTML = "";

      // Clone and append template content
      const clone = template.content.cloneNode(true);
      this.formContentTarget.appendChild(clone);
    }
  }

  #setModalTitle(formStepTitle) {
    this.titleTarget.textContent = formStepTitle;
  }

  #validatePaymentMethods() {
    this.#disableSubmitButton();
    const acceptsPayments = document.getElementById("accepts_payments_true");
    const enabledCash = document.getElementById("enable_cash");
    const paymentMethodInputsContainer = document.getElementById("payment-method-inputs");

    if (acceptsPayments.checked) {
      if (enabledCash.checked) {
        this.#enableSubmitButton();
      }
      paymentMethodInputsContainer.querySelectorAll("input[type='text']").forEach((input) => {
        if (input.value.trim()) {
          this.#enableSubmitButton();
        }
      });
    } else {
      this.#enableSubmitButton();
    }
  }
}
